<ion-item mode="md" color="gray" lines="none" class="ion-text-center item-copy">
  <ion-label
    [attr.data-test]="'Automation.txt-recover-message' | translate"
    mode="md"
    color="status-icon-enable"
    class="recover-password-enter-phone"
  >
    {{ "Labels.recover-password-enter-phone" | translate }}
  </ion-label>
</ion-item>

<form [formGroup]="telForm" (ngSubmit)="onSubmitTemplate()">
  <ion-item
    mode="md"
    lines="none"
    color="gray"
    class="mpe-input-square-floating"
  >
    <ion-label position="floating" mode="md" color="status-icon-enable">
      <ion-text mode="md" color="danger">
        {{ "Forms.asterisk" | translate }}
      </ion-text>
      {{ "Forms.number-of-phone" | translate }}
    </ion-label>

    <ion-input
      [attr.data-test]="'Automation.txtbox-recover-phone' | translate"
      type="tel"
      formControlName="phone"
      oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1')"
      mode="ios"
      color="medium"
      debounce="300"
      minlength="10"
      maxlength="10"
      enterkeyhint="done"
      (keydown.enter)="onSubmitTemplate()"
      [ngClass]="
        (telForm.get('phone').value | isNullEmpty)
          ? 'border-base'
          : telForm.get('phone').invalid
          ? 'border-danger'
          : 'border-valid'
      "
    >
    </ion-input>
    <!-- Manejo de Mensajes Reactivos -->
    <ng-container
      *ngIf="
        !(telForm.get('phone').value | isNullEmpty) &&
        telForm.get('phone').invalid
      "
    >
      <p>{{ "Labels.invalid-phone" | translate }}</p>
    </ng-container>
  </ion-item>

  <ion-item mode="md" color="gray" lines="none" class="item-accept">
    <ion-button
      [attr.data-test]="'Automation.btn-recover-confirm' | translate"
      class="aceptar"
      [disabled]="telForm.invalid || spinner"
      type="submit"
      color="darkblue"
    >
      <ion-spinner name="crescent" slot="start" *ngIf="spinner"></ion-spinner>
      <ion-label mode="md">
        {{ "Buttons.confirm" | translate }}
      </ion-label>
    </ion-button>
  </ion-item>
</form>
